import { useChannelTalk } from '@repo/channel-talk';

import Layout from '@/components/layout/Layout';
import ResultJointCertificateInstallContent from '@/components/tax-refund/result/JointCertificate/install/ResultJointCertificateInstallContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const ResultJointCertificateInstallPage = () => {
  const { openChannelTalk } = useChannelTalk();

  const handleClickRight = () => {
    openChannelTalk(SUPPORT_BOT_LINK.인증정보입력);
  };

  return (
    <Layout
      leftIcon={{ icon: 'back' }}
      rightTextButton={{
        label: '문의하기',
        state: 'gray',
        onClick: handleClickRight
      }}
    >
      <ResultJointCertificateInstallContent />
    </Layout>
  );
};

export default ResultJointCertificateInstallPage;
